import React, { useEffect, useState } from 'react';

const CelebrationEffect = ({ show, type }) => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    if (show) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 4000); // Show for 4 seconds
      
      return () => clearTimeout(timer);
    } else {
      // When show goes false, ensure visible is also cleared so the
      // component doesn't leave a remnant on screen.
      setVisible(false);
    }
  }, [show]);
  
  if (!visible) return null;
  
  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {/* Main glow effect */}
      <div 
        className="absolute inset-0"
        style={{
          background: type === 'sunset' 
            ? 'radial-gradient(circle, rgba(255,140,50,0.3) 0%, rgba(0,0,0,0) 70%)'
            : 'radial-gradient(circle, rgba(255,200,100,0.3) 0%, rgba(0,0,0,0) 70%)',
          opacity: visible ? 1 : 0,
          transition: 'opacity 2s ease-in-out'
        }}
      />
      
      {/* Rays of light */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div
          className="w-96 h-96"
          style={{
            background: type === 'sunset'
              ? 'conic-gradient(from 0deg, transparent 0deg, rgba(255,100,50,0.7) 20deg, transparent 40deg, transparent 60deg, rgba(255,180,50,0.7) 80deg, transparent 100deg, transparent 120deg, rgba(255,100,50,0.7) 140deg, transparent 160deg, transparent 180deg, rgba(255,100,0,0.7) 200deg, transparent 220deg, transparent 240deg, rgba(255,150,50,0.7) 260deg, transparent 280deg, transparent 300deg, rgba(255,100,50,0.7) 320deg, transparent 340deg, transparent 360deg)'
              : 'conic-gradient(from 0deg, transparent 0deg, rgba(255,220,150,0.7) 20deg, transparent 40deg, transparent 60deg, rgba(255,180,100,0.7) 80deg, transparent 100deg, transparent 120deg, rgba(255,220,150,0.7) 140deg, transparent 160deg, transparent 180deg, rgba(255,200,100,0.7) 200deg, transparent 220deg, transparent 240deg, rgba(255,220,150,0.7) 260deg, transparent 280deg, transparent 300deg, rgba(255,180,100,0.7) 320deg, transparent 340deg, transparent 360deg)',
            animation: 'celebrate-rays 4s linear forwards',
            borderRadius: '50%'
          }}
        />
      </div>
      
      {/* Central flare */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 rounded-full"
        style={{
          background: type === 'sunset'
            ? 'radial-gradient(circle, rgba(255,200,100,1) 0%, rgba(255,100,50,0.8) 50%, rgba(255,50,0,0) 100%)'
            : 'radial-gradient(circle, rgba(255,255,200,1) 0%, rgba(255,220,100,0.8) 50%, rgba(255,200,100,0) 100%)',
          animation: 'celebrate-flare 2s ease-out forwards'
        }}
      />
      
      {/* Smaller particles */}
      {[...Array(10)].map((_, i) => {
        const angle = (i / 10) * Math.PI * 2;
        const distance = 100 + Math.random() * 100;
        const size = 2 + Math.random() * 4;
        const delay = Math.random() * 0.5;
        const duration = 1 + Math.random() * 2;
        
        return (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              backgroundColor: type === 'sunset' ? '#FFAA50' : '#FFEE99',
              top: `calc(50% + ${Math.sin(angle) * distance}px)`,
              left: `calc(50% + ${Math.cos(angle) * distance}px)`,
              opacity: 0,
              animation: `celebrate-flare ${duration}s ease-out ${delay}s forwards`
            }}
          />
        );
      })}
    </div>
  );
};

export default CelebrationEffect;